import React from "react";
import {TableHeader, TableBody, TableFooter, TableRow} from '../../../common/table'

const headers = [
  { name: "ID", column: "id", sort: true },
  { name: "CARRIER NAME", column: "carriers.name", sort: true },
  { name: "STATUS", column: "state", sort: true },
  { name: "VERSION", column: "version", sort: true },
  { name: "STATE TAXES", column: "state_taxes", sort: false },
  { name: "MODE", column: "mode", sort: true },
  { name: "EFFECTIVE", column: "effective_at", sort: true },
  { name: "UPDATED", column: "updated_at", sort: true }
];

const fields = [
  { name: "id" },
  { name: "carrier.name" },
  { name: "state" },
  { name: "version_number" },
  {
    name: "state_taxes_enabled",
    render: (item) => item.state_taxes_enabled === true ?
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
      </svg>
      : ''
  },
  {
    name: 'mode'
  },
  {
    name: "effective_at",
    render: (item) => item.effective_at ? new Date(item.effective_at).toLocaleDateString("en-US") : null,
  },
  {
    name: "updated_at",
    render: (item) => new Date(item.updated_at).toLocaleDateString("en-US"),
  },
  {
    name: "id",
    key: "show",
    render: (item) => <a href={`/discounts/${item.id}`}>Show</a>,
  },
];

function DiscountsTable ({ discounts, query, updatePagination, updateSort }) {
  return (
    <div className="mt-4 flow-root mb-8">
      <div className='shadow ring-1 ring-black/5'>
        <div className="overflow-y-scroll overflow-x-auto max-h-[550px]">
          <div className="h-full overflow-y-auto">
            <table className="min-w-full divide-y divide-gray-300">
              <TableHeader
                headers={headers}
                sortDir={query.sort_direction}
                updateSort={updateSort}
                activeColumn={query.sort_column}
              />
              <TableBody rows={discounts}>
                {(row, idx) => (
                  <TableRow key={row.id} item={row} fields={fields} />
                )}
              </TableBody>
            </table>
          </div>
        </div>

        <TableFooter
          colSpan={headers.length}
          query={query}
          updatePagination={updatePagination}
        />
      </div>
    </div>
  );
};

export default DiscountsTable;
